export const citiesObjectSelector = state =>state.cityReducer.cities;

export const citiesDataSelector = state => state.cityReducer;
